import React, { Fragment, useState } from "react";
import styles from "./Upload.module.css";
import Header from "../../Components/Layout/Header";
import {
  Box,
  Card,
  CardContent,
  CircularProgress,
  Container,
  styled,
  Typography,
} from "@mui/material";
import upload from "../../Assets/Upload symbol.webp";
import { Link, useNavigate } from "react-router-dom";
import Parse from "../../API/ParseServer";
import Footer from "../../Components/Layout/Footer";

// const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({}));
const Upload = () => {
  const [uploadedImage, setUploadedImage] = useState<File>();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const navigate = useNavigate();
  const uploadChangeHandler = async (event: any) => {
    console.log(event.target.files[0]);
    if (
      event.target.files[0] &&
      (event.target.files[0].type === "image/png" ||
        event.target.files[0].type === "image/jpg" ||
        event.target.files[0].type === "image/jpeg")
    ) {
      if (event.target.files[0].size > 20000000) {
        setError(
          "Whoa! That file’s a mural. Compress it to under 20MB, please."
        );
        return;
      }
      setError("");
      const file = event.target.files[0];
      // console.log(file);x
      setUploadedImage(file);

      if (!file) return;

      setLoading(true);
      try {
        // Create a Parse File
        const parseFile = new Parse.File(file.name, file);
        await parseFile.save();
        console.log("1");
        // Create a new Artwork object
        const UserArtwork = Parse.Object.extend("UserArtwork");
        const userArtwork = new UserArtwork();
        userArtwork.set("image", parseFile);
        console.log("2");
        // Get image specifications
        const img = new Image();
        img.src = URL.createObjectURL(file);
        img.onload = async () => {
          // const resolution = `${img.width}x${img.height}`;
          const width = img.width;
          const height = img.height;
          // userArtwork.set("resolution", resolution);
          userArtwork.set("width", width);
          userArtwork.set("height", height);
          userArtwork.set("title", file.name);
          // Save the userArtwork object
          await userArtwork.save();
          setError("");
          localStorage.setItem("uploadImageId", userArtwork.id);
          console.log("Image uploaded successfully!");
          navigate("/online-printing/new");
        };
      } catch (error: any) {
        console.log(error.code);
        if (error.code === 122)
          setError(
            "Please select a simpler name for your file ( without ()!@#_ )"
          );
        // setError("Error uploading image.");
      } finally {
        setLoading(false);
      }
    } else {
      setError("We can’t hang that format - try JPG, JPEG, or PNG instead");
    }
  };
  return (
    <Fragment>
      <Container
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          textAlign: "center",
          mb: 10,
        }}
      >
        <Typography
          variant="h4"
          sx={{ my: 4, fontWeight: "bolder" }}
          component="h2"
        >
          Upload your image here
        </Typography>
        <Typography sx={{ color: "#949494" }} variant="h6">
          Please upload the highest resolution file you have for best results.
        </Typography>

        <div
          className={styles["upload-container"]}
          onClick={() => {
            const uploadInput = document.getElementById("upload");
            if (uploadInput) {
              uploadInput.click();
            }
          }}
        >
          <Card
            sx={{
              backgroundColor: "transparent",
              border: "1px solid #b4b4b4",
              boxShadow: "-3px 5px 18px #888888",
              cursor: "pointer",
              borderRadius: "40px",
            }}
          >
            <CardContent
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              {loading ? (
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    py: 15,
                    gap: 5,
                  }}
                >
                  <span className="loader"></span>
                  <Typography variant="h4">Uploading your image...</Typography>
                </Box>
              ) : (
                <img
                  src={upload}
                  alt="upload Artwork"
                  className={styles["card-image"]}
                />
              )}
              {error && (
                <Typography sx={{ color: "red", mb: 2 }}>{error}</Typography>
              )}
              <Typography variant="h5" sx={{ fontWeight: "bolder" }}>
                Upload your JPG, JPEG & PNG image
              </Typography>
            </CardContent>
          </Card>
        </div>
        <input
          type="file"
          name="upload"
          id="upload"
          hidden
          onChange={uploadChangeHandler}
          className={styles.upload}
        />
      </Container>
    </Fragment>
  );
};

export default Upload;
